import { Component, Input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { Invitation } from '@core/invitations-types';
import { DateComponent } from '@core/time-ui';
import {
  ButtonComponent,
  GroupComponent,
  HeadingComponent,
  IconComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-invitation-item',
  templateUrl: './invitation-item.component.html',
  styleUrls: ['./invitation-item.component.less'],
  imports: [
    ButtonComponent,
    DateComponent,
    GroupComponent,
    HeadingComponent,
    IconComponent,
    TruncateComponent,
    TranslatePipe,
  ],
})
export class InvitationItemComponent {
  @Input() public invitation: Invitation;
  @Input() public readOnly: boolean;

  public resendInvitation = output<Invitation>();
  public deleteClick = output<Invitation>();
}
